(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eba-class-builder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('eba-class-builder')) {
  customElements.define('eba-class-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.copy = this.querySelector('[data-copy]').dataset;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.photos = JSON.parse(this.querySelector('[data-photos]').textContent);
      this.querySelector(`[name="eba-style"][value="${this.dataset.defaultStyle}"]`).checked = true;
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-confirm]')) this.querySelector('[data-confirm]').checked = false;
        this.update();
      });
      this.querySelector('form').addEventListener('submit', event => {
        this.update();
        if (this.dataset.preview === 'true' || !this.selectedVariant?.available || !this.querySelector('[data-confirm]').checked || !this.querySelector('[data-year]').value) event.preventDefault();
      });
      this.update();
    }
    update() {
      const style = this.querySelector('[name="eba-style"]:checked').value;
      const design = 'bookstore';
      const crew = style === 'crew';
      this.querySelectorAll('[name="eba-color"], [name="eba-size"]').forEach(input => {
        const unavailable = crew && ['Ivory','4XL'].includes(input.value);
        input.disabled = unavailable;
        input.closest('label').hidden = unavailable;
        if (unavailable) input.checked = false;
      });
      if (!this.querySelector('[name="eba-color"]:checked')) this.querySelector('[name="eba-color"]').checked = true;
      const year = this.querySelector('[data-year]').value;
      const color = this.querySelector('[name="eba-color"]:checked').value;
      const size = this.querySelector('[name="eba-size"]:checked')?.value;
      const designName = 'The Bookstore';
      const designLabel = this.copy[design];
      const sampleYear = '1984';
      const image = this.querySelector('[data-mockup]');
      const photo = this.photos[style][design][color];
      if (image.getAttribute('src') !== photo) image.src = photo;
      image.alt = `${designLabel} · ${this.copy[style]} · ${color} · ${sampleYear}`;
      this.querySelector('[data-preview-caption]').textContent = `${this.copy.sample}: ${color} · ${this.dataset.classLabel} ${sampleYear}`;
      this.querySelector('[data-proof]').textContent = year ? `${this.dataset.classLabel} ${year}` : this.dataset.pending;
      this.querySelector('[data-summary]').textContent = year && size ? `${this.copy[style]} · ${designLabel} · ${this.dataset.classLabel} ${year} · ${color} · ${size}` : this.dataset.pending;
      const options = this.variants[style] || [];
      this.selectedVariant = options.find(variant => variant.options[0] === designName && variant.options[1] === color && variant.options[2] === size);
      const priceVariant = this.selectedVariant || options.find(variant => variant.options[0] === designName && variant.options[1] === color);
      this.querySelector('[data-price]').textContent = priceVariant ? priceVariant.price : this.copy[style + 'Price'];
      this.querySelector('[data-variant]').value = this.selectedVariant?.id || '';
      if (year && size && !this.selectedVariant?.available && this.dataset.preview !== 'true') this.querySelector('[data-summary]').textContent = this.dataset.unavailable;
      this.querySelector('[data-blank]').textContent = crew ? this.copy.crewBlank : this.copy.teeBlank;
      this.querySelector('[data-fabric]').textContent = crew ? this.copy.crewFabric : this.copy.teeFabric;
      this.querySelector('[data-tee-guide]').hidden = crew;
      this.querySelector('[data-crew-guide]').hidden = !crew;
      const button = this.querySelector('[data-submit]');
      button.disabled = this.dataset.preview === 'true' || !year || !this.selectedVariant?.available || !this.querySelector('[data-confirm]').checked;
      if (this.dataset.preview !== 'true') button.textContent = this.selectedVariant && !this.selectedVariant.available ? this.dataset.unavailable : this.dataset.add;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eba-flagship"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bootEbaMemoryRotators(scope) {
    scope.querySelectorAll('[data-eba-quote-rotator]').forEach(function (root) {
      if (root.dataset.ebaRotatorReady === 'yes') return;
      root.dataset.ebaRotatorReady = 'yes';
      const slides = Array.from(root.querySelectorAll('[data-eba-quote-slide]'));
      if (!slides.length) return;
      const prev = root.querySelector('[data-eba-quote-prev]');
      const next = root.querySelector('[data-eba-quote-next]');
      const pauseButton = root.querySelector('[data-eba-quote-pause]');
      const count = root.querySelector('[data-eba-quote-count]');
      const motionReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let index = 0;
      let timer = null;
      let manuallyPaused = false;

      function stop() {
        if (timer !== null) { window.clearInterval(timer); timer = null; }
      }
      function isExpanded() {
        return !!root.querySelector('details[data-eba-quote-details][open]');
      }
      function paint(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach(function (slide, number) {
          slide.classList.toggle('is-active', number === index);
          slide.setAttribute('aria-hidden', String(number !== index));
        });
        if (count) count.textContent = (index + 1) + ' / ' + slides.length;
      }
      function restart() {
        stop();
        if (slides.length < 2 || motionReduced || manuallyPaused || isExpanded() ||
            root.matches(':hover') || root.contains(document.activeElement) || document.hidden) return;
        timer = window.setInterval(function () {
          if (isExpanded() || root.matches(':hover') || root.contains(document.activeElement) || document.hidden) {
            stop();
            return;
          }
          paint(index + 1);
        }, 7000);
      }
      function changeBy(delta) {
        slides.forEach(function (slide) {
          const details = slide.querySelector('[data-eba-quote-details]');
          if (details) details.open = false;
        });
        paint(index + delta);
        restart();
      }
      root.classList.add('is-enhanced');
      paint(0);
      if (prev) prev.addEventListener('click', function () { changeBy(-1); });
      if (next) next.addEventListener('click', function () { changeBy(1); });
      if (pauseButton) {
        if (motionReduced) {
          pauseButton.textContent = 'Motion off';
          pauseButton.disabled = true;
          pauseButton.setAttribute('aria-pressed', 'true');
        } else {
          pauseButton.addEventListener('click', function () {
            manuallyPaused = !manuallyPaused;
            pauseButton.textContent = manuallyPaused ? 'Play' : 'Pause';
            pauseButton.setAttribute('aria-pressed', String(manuallyPaused));
            restart();
          });
        }
      }
      root.addEventListener('toggle', function (event) {
        if (event.target && event.target.matches && event.target.matches('[data-eba-quote-details]')) {
          if (event.target.open) stop();
          else restart();
        }
      }, true);
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', restart);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', function () { window.setTimeout(restart, 0); });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else restart();
      });
      restart();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootEbaMemoryRotators(document); });
  } else {
    bootEbaMemoryRotators(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    bootEbaMemoryRotators(event.target);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eba-header"]) return;
  try {
    
document.addEventListener('click', (event) => {
  if (event.target instanceof Element && event.target.closest('.eba-mobile-nav a')) {
    const menu = event.target.closest('details');
    if (menu) menu.open = false;
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.eba-mobile-nav[open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eba-home"] && !Shopify.designMode) return;
  try {
    
function initEbaHomeForms() {
  document.querySelectorAll('.eba-home').forEach(root => {
    const select = root.querySelector('[data-eba-home-request]');
    if (!select || select.dataset.ready) return;
    select.dataset.ready = 'true';
    const update = () => {
      root.querySelectorAll('[data-eba-home-fields]').forEach(group => {
        const active = group.dataset.ebaHomeFields === select.value;
        group.hidden = !active;
        group.querySelectorAll('input,textarea,select').forEach(field => {
          field.disabled = !active;
          field.required = active && field.hasAttribute('data-eba-home-required');
        });
      });
    };
    select.addEventListener('change', update);
    root.querySelectorAll('[data-eba-home-action]').forEach(link => {
      link.addEventListener('click', () => {
        select.value = link.dataset.ebaHomeAction;
        update();
      });
    });
    const form = root.querySelector('#EbaHomeForm');
    root.querySelectorAll('#EbaHomeBottle,#EbaHomeCode,#EbaHomeOrder').forEach(field => field.addEventListener('input',()=>{root.querySelector('#EbaHomeOrder').required=false;}));
    if (form) form.addEventListener('submit', event => {
      if (select.value === 'claim') {
        const number = root.querySelector('#EbaHomeBottle');
        const code = root.querySelector('#EbaHomeCode');
        const order = root.querySelector('#EbaHomeOrder');
        if (!(number.value && code.value.trim()) && !order.value.trim()) {
          event.preventDefault();
          order.required = true;
          order.reportValidity();
        }
      }
    });
    update();
  });
}
initEbaHomeForms();
document.addEventListener('shopify:section:load', initEbaHomeForms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
